import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRoutes } from 'react-router-dom';
// import { Router, Routes, Route, Link } from 'react-router-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
} from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Login from './components/Login';
import Register from './components/Register';
import Home from './components/Home';
import Profile from './components/Profile';
import BoardUser from './components/BoardUser';
import BoardModerator from './components/BoardModerator';
import BoardAdmin from './components/BoardAdmin';
import NinjaMain from './components/NinjaMain';
import OneLogin from './components/OneLogin';
import Report1 from 'pages/stepper4/components/reports/R1Frame';
import Report2 from 'pages/stepper4/components/reports/R2Frame';
import Report3 from 'pages/stepper4/components/reports/R3Frame';
import Report4 from 'pages/stepper4/components/reports/R4Frame';
import Create from './pages/ninja/Create';
import { logout } from './actions/auth';
import { clearMessage } from './actions/message';

import { history } from './helpers/history';
import { AllPages } from './app/routes/routes';

// import AuthVerify from "./common/AuthVerify";
import EventBus from './common/EventBus';
import CustomerForm from 'app/views/pages/customers/customer-form/CustomerForm';

const App = () => {
  const [showModeratorBoard, setShowModeratorBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  // const all_pages = useRoutes(AllPages());

  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    history.listen((location) => {
      dispatch(clearMessage()); // clear message when changing location
    });
  }, [dispatch]);

  const logOut = useCallback(() => {
    dispatch(logout());
  }, [dispatch]);

  useEffect(() => {
    if (currentUser) {
      setShowModeratorBoard(currentUser.roles.includes('ROLE_MODERATOR'));
      setShowAdminBoard(currentUser.roles.includes('ROLE_ADMIN'));
    } else {
      setShowModeratorBoard(false);
      setShowAdminBoard(false);
    }

    EventBus.on('logout', () => {
      logOut();
    });

    return () => {
      EventBus.remove('logout');
    };
  }, [currentUser, logOut]);

  return (
    // <Router history={history}>
    <Router>
      <div>
        {/* navbar navbar-expand navbar-dark bg-dark */}
        {/* https://themesberg.com/knowledge-center/bootstrap/override-bootstrap-css */}
        <nav className="navbar navbar-expand navbar-dark bg-001">
          <Link to={'/app'} className="navbar-brand">
            ระบบจัดทำเอกสารประกอบการจ้าง
          </Link>
          <div className="navbar-nav mr-auto">
            {/* <li className="nav-item">
              <Link to={'/app/home'} className="nav-link">
                Home
              </Link>
            </li> */}

            {showModeratorBoard && (
              <li className="nav-item">
                <Link to={'/app/mod'} className="nav-link">
                  {/* Moderator Board */}
                  MB
                </Link>
              </li>
            )}

            {showAdminBoard && (
              <li className="nav-item">
                <Link to={'/app/admin'} className="nav-link">
                  {/* Admin Board */}
                  AB
                </Link>
              </li>
            )}

            {currentUser && (
              <li className="nav-item">
                <Link to={'/app/user'} className="nav-link">
                  User
                </Link>
              </li>
            )}
          </div>

          {currentUser ? (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={'/app/profile'} className="nav-link">
                  {currentUser.username}
                </Link>
              </li>
              <li className="nav-item">
                <Link to={'/app/employment'} className="nav-link">
                  employment
                </Link>
              </li>
              <li className="nav-item">
                <a href="/app/login" className="nav-link" onClick={logOut}>
                  LogOut
                </a>
              </li>
            </div>
          ) : (
            <div className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link to={'/app/login'} className="nav-link">
                  Login
                </Link>
              </li>

              <li className="nav-item">
                <Link to={'/app/register'} className="nav-link">
                  Sign Up
                </Link>
              </li>

              <li className="nav-item">
                {/* <Link to={'/api/onelogin'} className="nav-link">
                  OneLogin
                </Link> */}
                {/* <a href={'/api/onelogin/login'} className="nav-link">
                  OneLogin
                </a> */}
              </li>
            </div>
          )}
        </nav>

        <div>
          {/* <div className="container mt-3"> */}
          {/* {all_pages} */}
          <Routes>
            {/* <Route exact path={['/', '/home']} component={Home} /> */}
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/" element={<Navigate to="/app/employment" replace />} />
            <Route path="/app" element={<Navigate to="/app/employment" replace />} />
            <Route path="/app/home" element={<Home />} />
            {/* <Route path={('/', '/home')} element={<Home />} /> */}
            <Route path="/app/login" element={<Login />} />
            <Route path="/app/register" element={<Register />} />
            <Route path="/app/profile" element={<Profile />} />
            {/* https://stackoverflow.com/questions/69988285/nested-routing-in-react-router-dom-v6 */}
            <Route path="/app/employment/*" element={<NinjaMain />}>
              {/* <Route
                path={`/ninja-egat-customer-form`}
                element={<CustomerForm />}
              /> */}
            </Route>
            {/* <Route
            index // <-- "/"
            element={<div>Default Page Content</div>}
          /> */}
            {/* <Route
              path="/ninja-egat-customer-form"
              element={<CustomerForm />}
            /> */}
            {/* <Route path="/create" component={Create} /> */}
            <Route path="/app/user" element={<BoardUser />} />
            <Route path="/app/mod" element={<BoardModerator />} />
            <Route path="/app/admin" element={<BoardAdmin />} />
            <Route path="/app/report1" element={<Report1 />} />
            <Route path="/app/report2" element={<Report2 />} />
            <Route path="/app/report3" element={<Report3 />} />
            <Route path="/app/report4" element={<Report4 />} />
            <Route path="/app/onelogin" element={<OneLogin />} />
          </Routes>
        </div>
        {/* <AuthVerify logOut={logOut}/> */}
      </div>
    </Router>
  );
};

export default App;
